import { connect } from '@atlassian/jira-react-redux';
import { getIsAdmin } from '../../state/context/selectors';
import type { AppState } from '../../state/types';
import { getSimplifiedSelector } from '../../state/ui/selectors';
import Menu from './menu';
import Header from './view';

const mapStateToProps = (state: AppState) => ({
	Menu,
	isSimplified: getSimplifiedSelector(state),
	isAdmin: getIsAdmin(state),
});

export default connect(mapStateToProps, {})(Header);
